class Chart {
  constructor({
    id = null,
    title = '',
    description = '',
    apiName = '',
    layout = null,
    queryParams = {},
    aggregations = {},
    createdAt = null,
    updatedAt = null,
    uid = null,
  } = {}) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.apiName = apiName;
    this.layout = layout;
    this.queryParams = queryParams;
    this.aggregations = aggregations;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.uid = uid;
  }

  setData(data) {
    this.id = data.id;
    this.title = data.title;
    this.description = data.description;
    this.apiName = data.apiName;
    this.layout = data.layout;
    this.queryParams = data.queryParams || {};
    this.aggregations = data.aggregations || {};
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.uid = data.uid;
  }

  toUpdate() {
    return {
      title: this.title,
      layout: this.layout,
      description: this.description,
      apiName: this.apiName,
      queryParams: this.queryParams,
      aggregations: this.aggregations,
    };
  }
}

export default Chart;
